/// <amd-module name="typeahead/core/userfeedbacktool/data/UserFeedbackDataLogger" />
/// <reference path="../../../../typings/typeahead/dctk.d.ts" />
import {CollectorTransport} from "typeahead/core/logging/CollectorTransport";
import {InputClearedMessage} from "typeahead/core/message/InputClearedMessage";
import {InputValueEditedMessage} from "typeahead/core/message/InputValueEditedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {UserExitedMessage} from "typeahead/core/message/UserExitedMessage";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export enum SearchType {
    typeahead, resolve,
}

export interface IUserFeedbackParams {
    areSuggestionsHelpful: boolean;
    comment?: string;
    expectedDestinationTypes?: string[];
    lob: string;
    issueType?: string;
    issueTypeOther?: string;
    searchQuery: string;
    searchType: SearchType;
    tnls?: string;
}

interface IUserFeedbackData {
        areSuggestionsHelpful: string;
        browser: string;
        browserVersion: string;
        deviceType: string;
        guid: string;
        issueType: string;
        issueTypeOther: string;
        expectedDestinationTypes: string[];
        comment: string;
        lob: string;
        locale: string;
        pageId: string;
        platform: string;
        pointOfSale: string;
        siteId: string;
        timestamp: string;
        tnls: string[];
        userAgent: string;
        searchQuery: string;
        searchType: string;
}

export class UserFeedbackDataLogger {
    public static getSingleton(): UserFeedbackDataLogger {
        if (!this.instance) {
            this.instance = new UserFeedbackDataLogger();
        }
        return this.instance;
    }
    private static instance: UserFeedbackDataLogger;

    private static getUserFeedbackData(params: IUserFeedbackParams): IUserFeedbackData {
        return {
            areSuggestionsHelpful: params.areSuggestionsHelpful ? "yes" : "no",
            browser: (dctk && dctk.logging && dctk.logging.browser) || "",
            browserVersion: (dctk && dctk.logging && dctk.logging.version) || "",
            comment: params.comment,
            deviceType: TypeaheadUtils.getDeviceType(),
            expectedDestinationTypes: params.expectedDestinationTypes,
            guid: TypeaheadUtils.getGuid(),
            issueType: params.issueType,
            issueTypeOther: params.issueTypeOther,
            lob: params.lob,
            locale: TypeaheadUtils.getLocale(),
            pageId: TypeaheadUtils.getPageId(),
            platform: (dctk && dctk.logging && dctk.logging.OS) || "",
            pointOfSale: TypeaheadUtils.getPointOfSale(),
            searchQuery: params.searchQuery,
            searchType: SearchType[params.searchType],
            siteId: TypeaheadUtils.getSiteId(),
            timestamp: Date.now() + "",
            tnls: params.tnls && params.tnls.length ? params.tnls.split("|") : undefined,
            userAgent: navigator.userAgent,
        };
    }

    private data: IUserFeedbackData;
    private readonly collectorTransport: CollectorTransport = new CollectorTransport();

    private constructor() {
        TypeaheadMessage.subscribe(
            InputClearedMessage.getTopic(), () => {
                this.emitToCollector();
            },
        );

        TypeaheadMessage.subscribe(
            InputValueEditedMessage.getTopic(), () => {
                this.emitToCollector();
            },
        );

        TypeaheadMessage.subscribe(
            UserExitedMessage.getTopic(), () => {
                this.emitToCollector();
            },
        );
    }

    public log(params: IUserFeedbackParams, logImmediately: boolean): void {
        this.data = UserFeedbackDataLogger.getUserFeedbackData(params);
        if (logImmediately) {
            this.emitToCollector();
        }
    }

    private emitToCollector(): void {
        if (this.data) {
            this.collectorTransport.log(this.data, "typeahead_userfeedback");
            this.data = null;
        }
    }
}
